/**
 * Get recently viewed products.
 */
function getRecentlyViewedProducts() {
  const productData = JSON.parse(localStorage.getItem('recentlyViewedProduct'));
  const recentlyViewedCarousel = document.querySelector('[js-featured-collection="recently-viewed"]');
  const sliderComponent = document.querySelector('[data-type="recently-viewed"]');
  if (!Array.isArray(productData) || productData.length === 0) return;
  if (!sliderComponent || typeof sliderComponent.initPages !== 'function') return;

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        sliderComponent.sliderItems = sliderComponent.querySelector(
          '[js-featured-collection="recently-viewed"]'
        ).childNodes;
        if (sliderComponent.sliderItems.length > 0) {
          sliderComponent.initPages();
          observer.disconnect();

          if (sliderComponent.sliderItems.length > 10) {
            document.querySelector('[js-featured-collection="slider-buttons"]').classList.remove('hidden');
          }
        }
      }
    });
  });
  observer.observe(recentlyViewedCarousel, { childList: true, subtree: true });

  const recentlyViewedHtml = [];
  productData.map((item, index) => {
    const secondaryImageHtml = window.featuredCollection
      ? `<img class="motion-reduce" src="${item.productSecondaryImg}" loading="lazy" alt="${item.productSecondaryImageAltText}">`
      : '';
    const cardBadge = item.productTagTitle
      ? `<span class="badge" style="color:${item.productTagTextColor}; background-color:${item.productTagBackgroundColor};">${item.productTagTitle}</span>`
      : '';
    const cardPersonalise = item.iconDraw
      ? `<span class="personalise">${item.iconDraw}<span>${window.featuredCollection.personaliseLabel}</span></span>`
      : '';
    const fromLabel = item.fromPrice ? `<em>${window.featuredCollection.priceFromLabel}</em>` : '';
    const saleprice = item.saleprice
      ? `<span><s class="price-item price-item--regular">${item.saleprice}</s></span>`
      : '';
    const currencyCode = item.currencyCode ? Shopify.currency.active : '';
    recentlyViewedHtml.unshift(`
    <li
      id=${recentlyViewedCarousel.id}-${index}"
      class="featured-collection__grid-item grid__item slider__slide scroll-trigger animate--slide-in"
      js-featured-collection="recently-viewed-slide"
    >
      <div class="card-wrapper product-card-wrapper underline-links-hover">
        <div class="card card--standard card--media" style="--ratio-percent: 100%;">
          <div class="card__inner color-background-1 gradient ratio" style="--ratio-percent: 100%;">
            <div class="card__media">
              <a href="${item.productUrl}">
                <div class="media media--transparent media--hover-effect">
                  <img class="motion-reduce" src="${item.productImg}" loading="lazy" alt="${item.productImageAltText}">
                  ${secondaryImageHtml}
                </div>
              </a>
            </div>
            <div class="card__content">
              <div class="card__badge top left">
                ${cardBadge}
              </div>
              <div class="card__badge bottom right">
                ${cardPersonalise}
              </div>
              <div class="card__badge top right">
                <button
                  class="wishlist swym-button swym-add-to-wishlist-view-product product_${item.productId}"
                  data-with-epi="true"
                  data-swaction="addToWishlist"
                  data-product-id="${item.productId}"
                  data-variant-id="${item.productVariantId}"
                  data-product-url="${window.shopUrl}${item.productUrl}"
                >
                  ${window.featuredCollection.iconWishlist}
                </button>
              </div>
            </div>
          </div>
          <div class="card__content">
            <div class="card__information">
              <h3 class="card__heading h5">
                <a href="${item.productUrl}" class="full-unstyled-link">
                  ${item.productTitle}
                </a>
              </h3>
              <div class="card-information">
                <div class="price">
                  <div class="price__regular">
                    <span class="price-item price-item--regular">
                      ${fromLabel}
                      ${saleprice}
                      ${item.productPrice}
                      ${currencyCode}
                    </span>
                  </div>
                </div>
                <div class="feefo-product-stars-widget" data-parent-product-sku="${item.productId}"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </li>
   `);
  });
  recentlyViewedCarousel.innerHTML = `${recentlyViewedHtml.join('')}`;
}

/**
 * Toggle carousel visibility.
 */
function toggleCarousel() {
  const filterButtons = document.querySelectorAll('[js-featured-collection="filter-button"]');

  filterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      filterButtons.forEach((btn) => btn.classList.remove('is-active'));
      button.classList.add('is-active');

      const targetType = button.getAttribute('data-target');
      if (!targetType) return;

      document.querySelectorAll('[js-featured-collection="carousel"]').forEach((slider) => {
        if (slider.getAttribute('data-type') !== targetType) {
          slider.classList.add('hidden');
          return;
        }

        slider.classList.remove('hidden');
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', function (event) {
  getRecentlyViewedProducts();
  toggleCarousel();
});
